import i18next from 'i18next';

i18next.addResources('es_CL', 'ActionButtons', {
  reject: 'Rechazar',
  accept: 'Aceptar'
});

i18next.addResources('es_CR', 'ActionButtons', {
  reject: 'Rechazar',
  accept: 'Aceptar'
});
